module.exports = __webpack_public_path__ + "static/media/sha.7c828ab4.png";